/** Bound one tenant-settings attempt; stale/late reads never publish authority. */
export const SHELL_CONFIG_READ_TIMEOUT_MS = 15_000;

export function readShellConfig<T>(options: {
  read: () => Promise<T | null>;
  onSuccess: (config: T) => void;
  onError: () => void;
  timeoutMs?: number;
}): () => void {
  let active = true;
  const fail = () => {
    if (!active) return;
    active = false;
    clearTimeout(timer);
    options.onError();
  };
  const timer = setTimeout(fail, options.timeoutMs ?? SHELL_CONFIG_READ_TIMEOUT_MS);
  Promise.resolve()
    .then(options.read)
    .then((config) => {
      if (!active) return;
      if (config === null) {
        fail();
        return;
      }
      try {
        options.onSuccess(config);
        active = false;
        clearTimeout(timer);
      } catch {
        fail();
      }
    }, fail);
  return () => {
    active = false;
    clearTimeout(timer);
  };
}
